var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6094 4.96094C19.7656 4.84375 20 4.96094 20 5.15625V13.125C20 14.1797 19.1406 15 18.125 15H1.875C0.820312 15 0 14.1797 0 13.125V5.15625C0 4.96094 0.195312 4.84375 0.351562 4.96094C1.25 5.66406 2.38281 6.52344 6.36719 9.41406C7.1875 10 8.59375 11.2891 10 11.2891C11.3672 11.2891 12.8125 10 13.5938 9.41406C17.5781 6.52344 18.7109 5.66406 19.6094 4.96094ZM10 10C9.0625 10.0391 7.77344 8.86719 7.10938 8.39844C1.91406 4.64844 1.52344 4.29688 0.351562 3.35938C0.117188 3.20312 0 2.92969 0 2.61719V1.875C0 0.859375 0.820312 0 1.875 0H18.125C19.1406 0 20 0.859375 20 1.875V2.61719C20 2.92969 19.8438 3.20312 19.6094 3.35938C18.4375 4.29688 18.0469 4.64844 12.8516 8.39844C12.1875 8.86719 10.8984 10.0391 10 10Z",
    fill: "#DFEC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconYellow);
export default __webpack_public_path__ + "static/media/email-icon-yellow.1996ec363774c681513d10c21d47c41b.svg";
export { ForwardRef as ReactComponent };